export const UPDATE_DATA = 'app/EditSessionPage/Feedback/UPDATE';

export const UPDATE_FORMULA = 'app/EditSessionPage/Feedback/UPDATE_FORMULA';

export const ADD_FORMULA_CASE = 'app/EditSessionPage/Feedback/ADD_FORMULA_CASE';

export const REMOVE_FORMULA_CASE =
  'app/EditSessionPage/Feedback/REMOVE_FORMULA_CASE';

export const UPDATE_FORMULA_CASE =
  'app/EditSessionPage/Feedback/UPDATE_FORMULA_CASE';
